import { defineStore, StoreDefinition } from "pinia"
import { ICustomSchemaStore } from "../models/ICustomSchemaStore"
import configService from "@/services/configService"


export class SchemaStoreService {
    public static useCustomSchemaStore: StoreDefinition<
        'customSchemas',
        ICustomSchemaStore,
        {},
        {}
    > = defineStore('customSchemas', {
        state: (): ICustomSchemaStore => {
            const prefix = configService.getApplicationDeploymentPrefix()

            return {
                customReportsSchemaLocation: prefix,
                customReportsSchemas: [],
                calculationSchemaLocation: prefix,
                calculationSchemas: [],
                plotSchemaLocation: prefix,
                plotSchemas: [],
                tableSchemaLocation: prefix,
                tableSchemas: [],
                ruleSchemaLocation: prefix,
                ruleSchemas: [],
                analysisConfigSchemaLocation: prefix,
                analysisConfigSchemas: [],
                advancedAnalysisSchemaLocation: prefix,
                advancedAnalysisSchemas: [],
            }
        },
    })
}